import * as React from 'react';
import { makeStyles } from '@mui/styles';
import { Dialog } from '@mui/material';

const useStyles = makeStyles({
  dialog: {
    position: 'absolute',
    top: 10,
    width:500
  }
});
export default function ConfirmationModel(props) {
  const classes = useStyles();
const deleteRow=()=>{
  props.deleteFunction()
}
   const handleClose = () => {
    props.setOpen(false);
  };

  return (
    <div>
   <Dialog
      classes={{
        paper: classes.dialog
      }}
        open={props.open}
        BackdropProps={{ invisible: false, style: { backgroundColor: '#ffffffbf '} }}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
  <div className="oe-popup-layout">
    <div className="oe-popup-layout__body">
      <div className="alert-body">
        <span className="alert-message">Are you sure you want to <span className="alert-message--danger"> delete this {props.name}</span>?  {props.name===' OEC Account Link'?' This will delete all associated mappings':''}</span>
      </div>
    </div>
    <div className="oe-popup-layout__footer">
      <div className="buttons-block buttons-block--from-right">
        <button type="button" onClick={deleteRow} className="default-button default-button--fat default-button--confirm-warn">
          <span>Delete {props.name==='passport template'||props.name===' OEC Account Link'?'':props.name}</span>
        </button>
        <button type="button" onClick={handleClose} className="default-button default-button--fat default-button--cancel">
          <span>Cancel</span>
        </button>
      </div>
    </div>
  </div>
      </Dialog>
    </div>
  );
}


